export default "__VITE_ASSET__5fcf542c__"